import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import MedicationWidgetState, {MedicationPrice} from "../../types/MedicationWidget";
import InitialContext from "../../static-data/InitialContext";

const INITIAL_STATE: MedicationWidgetState = {
    currentMedicationPrice: InitialContext.getInitialMedicationPrice(),
};

const slice = createSlice({
    name: 'current-medication-price',
    initialState: INITIAL_STATE,
    reducers: {
        setCurrentMedicationPrice: (state, action: PayloadAction<MedicationPrice>) => {
            state.currentMedicationPrice = action.payload;
        }
    }
})

export const {setCurrentMedicationPrice} = slice.actions;

export default slice.reducer;